import { render, staticRenderFns } from "./purchases.vue?vue&type=template&id=eb1e8166"
import script from "./purchases.ts?vue&type=script&lang=js&external"
export * from "./purchases.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports